// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toast Provider Stack */
.scl--toastProvider__stack {
  position: fixed;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
}

.scl--toastProvider__stack--bl { left: 24px; bottom: 24px; }
.scl--toastProvider__stack--br { right: 24px; bottom: 24px; }
.scl--toastProvider__stack--bc { left: 50%; bottom: 24px; transform: translateX(-50%); }
.scl--toastProvider__stack--tl { left: 24px; top: 24px; }
.scl--toastProvider__stack--tr { right: 24px; top: 24px; }
.scl--toastProvider__stack--tc { left: 50%; top: 24px; transform: translateX(-50%); }

.scl--toastProvider__item {
  animation: tp-slide-in 0.3s ease forwards;
  pointer-events: auto;
}

.scl--toastProvider__item.tp-exit {
  animation: tp-slide-out 0.3s ease forwards;
}

@keyframes tp-slide-in {
  from { opacity: 0; transform: translateX(-24px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes tp-slide-out {
  from { opacity: 1; transform: translateX(0); }
  to { opacity: 0; transform: translateX(-24px); }
}

/* Toast Component */
.scl--toast {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 16px;
  width: 343px;
  min-height: 93px;
  background: #0A0A0A;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.14), 0px 6px 30px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  overflow: hidden;
  isolation: isolate;
  box-sizing: border-box;
}

/* Radial Gradient Glow */
.scl--toast__glow {
  position: absolute;
  width: 240px;
  height: 240px;
  left: -74px;
  top: -65px;
  pointer-events: none;
  z-index: 0;
}

.scl--toast__glow--success {
  background: radial-gradient(50% 50% at 50% 50%, rgba(132, 165, 120, 0.12) 0%, rgba(0, 237, 123, 0) 100%);
}

.scl--toast__glow--warning {
  background: radial-gradient(50% 50% at 50% 50%, rgba(255, 193, 142, 0.13) 0%, rgba(240, 66, 72, 0) 100%);
}
.scl--toast__glow--error {
  background: radial-gradient(50% 50% at 50% 50%, rgba(248, 134, 138, 0.13) 0%, rgba(240, 66, 72, 0) 100%);
}



/* Icon Container */
.scl--toast__icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px;
  width: 32px;
  height: 32px;
  border-radius: 43px;
  flex: none;
  flex-grow: 0;
  z-index: 1;
  box-sizing: border-box;
}

.scl--toast__icon--success {
  background: rgba(132, 165, 120, 0.03);
}

.scl--toast__icon--error {
  background: rgba(255, 139, 143, 0.03);
}

.scl--toast__icon--warning {
  background: rgba(240, 145, 67, 0.03);
}

/* Text Block */
.scl--toast__text-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 5px;
  flex: 1;
  z-index: 1;
}

.scl--toast__text-block--no-icon {
  padding-left: 48px;
}

.scl--toast__title {
  width: 100%;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: #FFFFFF;
}

.scl--toast__description {
  width: 100%;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: #C8C5C5;
}

/* Bottom Line */
.scl--toast__bottom-line {
  position: absolute;
  width: calc(100% + 40px);
  height: 3px;
  left: -20px;
  bottom: 0;
  border-radius: 10px;
  z-index: 2;
}

.scl--toast__bottom-line--success {
  background: #84A578;
}

.scl--toast__bottom-line--warning {
  background: #FFC18E;
}

.scl--toast__bottom-line--error {
  background: #F8868A;
}

/* Bottom Line Blur Effect */
.scl--toast__bottom-line-blur {
  position: absolute;
  width: calc(100% + 40px);
  height: 3px;
  left: -20px;
  bottom: 0;
  filter: blur(2px);
  border-radius: 10px;
  z-index: 1;
}

.scl--toast__bottom-line-blur--success {
  background: #84A578;
}

.scl--toast__bottom-line-blur--warning {
  background: #F09143;
}

.scl--toast__bottom-line-blur--error {
  background: #F04349;
}

/* Responsive adjustments */
@media (max-width: 400px) {
  .scl--toast {
    width: calc(100vw - 32px);
    max-width: 343px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/context-module/context-configuration/toast-provider/bottomToast/css/ToastProvider.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA,iCAAiC,UAAU,EAAE,YAAY,EAAE;AAC3D,iCAAiC,WAAW,EAAE,YAAY,EAAE;AAC5D,iCAAiC,SAAS,EAAE,YAAY,EAAE,2BAA2B,EAAE;AACvF,iCAAiC,UAAU,EAAE,SAAS,EAAE;AACxD,iCAAiC,WAAW,EAAE,SAAS,EAAE;AACzD,iCAAiC,SAAS,EAAE,SAAS,EAAE,2BAA2B,EAAE;;AAEpF;EACE,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC7C,KAAK,UAAU,EAAE,4BAA4B,EAAE;AACjD;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gHAAgH;EAChH,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,wGAAwG;AAC1G;;AAEA;EACE,wGAAwG;AAC1G;AACA;EACE,wGAAwG;AAC1G;;;;AAIA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;AACF","sourcesContent":["/* Toast Provider Stack */\n.scl--toastProvider__stack {\n  position: fixed;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  pointer-events: none;\n}\n\n.scl--toastProvider__stack--bl { left: 24px; bottom: 24px; }\n.scl--toastProvider__stack--br { right: 24px; bottom: 24px; }\n.scl--toastProvider__stack--bc { left: 50%; bottom: 24px; transform: translateX(-50%); }\n.scl--toastProvider__stack--tl { left: 24px; top: 24px; }\n.scl--toastProvider__stack--tr { right: 24px; top: 24px; }\n.scl--toastProvider__stack--tc { left: 50%; top: 24px; transform: translateX(-50%); }\n\n.scl--toastProvider__item {\n  animation: tp-slide-in 0.3s ease forwards;\n  pointer-events: auto;\n}\n\n.scl--toastProvider__item.tp-exit {\n  animation: tp-slide-out 0.3s ease forwards;\n}\n\n@keyframes tp-slide-in {\n  from { opacity: 0; transform: translateX(-24px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes tp-slide-out {\n  from { opacity: 1; transform: translateX(0); }\n  to { opacity: 0; transform: translateX(-24px); }\n}\n\n/* Toast Component */\n.scl--toast {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 12px 16px;\n  gap: 16px;\n  width: 343px;\n  min-height: 93px;\n  background: #0A0A0A;\n  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.14), 0px 6px 30px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.2);\n  border-radius: 2px;\n  overflow: hidden;\n  isolation: isolate;\n  box-sizing: border-box;\n}\n\n/* Radial Gradient Glow */\n.scl--toast__glow {\n  position: absolute;\n  width: 240px;\n  height: 240px;\n  left: -74px;\n  top: -65px;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.scl--toast__glow--success {\n  background: radial-gradient(50% 50% at 50% 50%, rgba(132, 165, 120, 0.12) 0%, rgba(0, 237, 123, 0) 100%);\n}\n\n.scl--toast__glow--warning {\n  background: radial-gradient(50% 50% at 50% 50%, rgba(255, 193, 142, 0.13) 0%, rgba(240, 66, 72, 0) 100%);\n}\n.scl--toast__glow--error {\n  background: radial-gradient(50% 50% at 50% 50%, rgba(248, 134, 138, 0.13) 0%, rgba(240, 66, 72, 0) 100%);\n}\n\n\n\n/* Icon Container */\n.scl--toast__icon {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  width: 32px;\n  height: 32px;\n  border-radius: 43px;\n  flex: none;\n  flex-grow: 0;\n  z-index: 1;\n  box-sizing: border-box;\n}\n\n.scl--toast__icon--success {\n  background: rgba(132, 165, 120, 0.03);\n}\n\n.scl--toast__icon--error {\n  background: rgba(255, 139, 143, 0.03);\n}\n\n.scl--toast__icon--warning {\n  background: rgba(240, 145, 67, 0.03);\n}\n\n/* Text Block */\n.scl--toast__text-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 5px;\n  flex: 1;\n  z-index: 1;\n}\n\n.scl--toast__text-block--no-icon {\n  padding-left: 48px;\n}\n\n.scl--toast__title {\n  width: 100%;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.5px;\n  color: #FFFFFF;\n}\n\n.scl--toast__description {\n  width: 100%;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 12px;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.5px;\n  color: #C8C5C5;\n}\n\n/* Bottom Line */\n.scl--toast__bottom-line {\n  position: absolute;\n  width: calc(100% + 40px);\n  height: 3px;\n  left: -20px;\n  bottom: 0;\n  border-radius: 10px;\n  z-index: 2;\n}\n\n.scl--toast__bottom-line--success {\n  background: #84A578;\n}\n\n.scl--toast__bottom-line--warning {\n  background: #FFC18E;\n}\n\n.scl--toast__bottom-line--error {\n  background: #F8868A;\n}\n\n/* Bottom Line Blur Effect */\n.scl--toast__bottom-line-blur {\n  position: absolute;\n  width: calc(100% + 40px);\n  height: 3px;\n  left: -20px;\n  bottom: 0;\n  filter: blur(2px);\n  border-radius: 10px;\n  z-index: 1;\n}\n\n.scl--toast__bottom-line-blur--success {\n  background: #84A578;\n}\n\n.scl--toast__bottom-line-blur--warning {\n  background: #F09143;\n}\n\n.scl--toast__bottom-line-blur--error {\n  background: #F04349;\n}\n\n/* Responsive adjustments */\n@media (max-width: 400px) {\n  .scl--toast {\n    width: calc(100vw - 32px);\n    max-width: 343px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
